<template>
  <a-modal
    centered
    v-model:visible="locationModalVisible"
    :closable="false"
    :okText="$t('js.them_dia_diem')"
    :cancelText="$t('js.huy_34ca764c')"
    @cancel="clickCancel"
    @ok="clickOk"
  >
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24">
          <a-form-item :label="locationTitle">
           
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="8" v-show="locationSelectVisible">
        <a-col :sm="{ span: 24}" :md="{ span: 12}">
          <a-form-item :label="$t('js.tinh_thanh_pho')">
            <a-select
              v-model="location.province"
              style="width: 100%"
              @change="handleProvinceChange"
            >
              <a-select-option v-for="item in provinces" :key="item.id">{{item.text}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :sm="{ span: 24}" :md="{ span: 12}">
          <a-form-item :label="$t('js.quan_huyen')">
            <a-select
              v-model="location.district"
              style="width: 100%"
              @change="handleDistrictChange"
            >
              <a-select-option v-for="item in districts" :key="item.id">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="8">
        <a-col :span="24">
          <a-form-item :label="$t('js.dia_chi_chi_tiet')">
            <a-input v-model="location.address">
              <!-- <a-icon slot="prefix" type="form"></a-icon> -->
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import axios from "axios";
import  AppConstant  from "@/constant";

const provinces = [
  {
    id: 0,
    text: window.__t('js.chon_dia_diem')
  }
];
const districts = [
  {
    id: 0,
    text: window.__t('js.chon_dia_diem')
  }
];
export default {
  data: () => ({
    config: {
      rules: [
        { type: "object", required: true, message: window.__t('js.vui_long_nhap_thong_tin') }
      ]
    },

    center: { lat: 21.0031177, lng: 105.82014079999999 },
    markers: [],
    locationSelectVisible: false,
    provinces,
    districts,
    autocompleteOptions: {
      componentRestrictions: {
        country: ["VN"]
      }
    }
  }),
  props: {
    locationModalVisible: false,
    location: {
      country: "0",
      province: "0",
      district: "0",
      address: "",
      full_address: "",
      latitude: 0,
      longitude: 0
    },
    locationType: {
      type: Number, // not 'number'
      required: false,
      default: 1
    }
  },
  computed: {
    locationTitle: function() {
      return this.locationType == AppConstant.LocationType.Destination
        ? window.__t('js.diem_nhan_hang')
        : window.__t('js.diem_tra_hang');
    }
  },
  beforeCreate() {},
  mounted() {
    axios
      .get("province")
      .then(response => {
        this.provinces = response.data.results;
        if (this.provinces.length > 0) {
          this.location.province = this.provinces[0].id;
          this.fetchDistrict(this.location.province, false, () => {
            this.location.district = this.districts[0].id;
          });
        } else {
          this.location.province = 0;
        }
      })
      .catch(error => {
        console.log(error.toString());
      });
  },
  methods: {
    clickOk() {
      this.$emit("emit-location", {
        locationType: this.locationType,
        location: this.location
      });
    },
    createAddressDetail() {
      this.location.full_address =
        this.location.address +
        ", " +
        (this.districts.find(p => p.id == this.location.district).text || "") +
        ", " +
        (this.provinces.find(p => p.id == this.location.province).text || "");
      this.searchLocation(this.location.full_address);
    },
    clickCancel() {
      this.$emit("emit-location", {
        locationType: this.locationType,
        location: null
      });
    },
    setPlace(place) {
      if (!place) {
        this.locationSelectVisible = false;
        return;
      }
      this.locationSelectVisible = true;
      const address = {};
      let ac = place.address_components;
      if (ac) {
        ac.forEach(item => {
          if (item.types) {
            item.types.forEach(key => {
              address[key] = item["short_name"];
            });
          }
        });
      }
      if (place.geometry) {
        this.location.latitude = place.geometry.location.lat();
        this.location.longitude = place.geometry.location.lng();
      }

      this.location.country = address.country;
      this.location.province = this.provinces.find(
        p => p.text == address.administrative_area_level_1
      )
        ? this.provinces.find(
            p => p.text == address.administrative_area_level_1
          ).id
        : this.provinces[0].id;

      if (this.location.province) {
        this.fetchDistrict(this.location.province, true, () => {
          this.location.district = this.districts.find(
            p =>
              p.text == address.administrative_area_level_2 ||
              p.text == address.locality
          )
            ? this.districts.find(
                p =>
                  p.text == address.administrative_area_level_2 ||
                  p.text == address.locality
              ).id
            : this.districts[0].id;
          this.location.address = place.formatted_address
            ? place.formatted_address
            : place.name;
          this.createAddressDetail();
        });
      } else {
        this.location.address = place.formatted_address
          ? place.formatted_address
          : place.name;
        this.createAddressDetail();
      }
    },
    fetchProvince(loading) {
      let loader = null;
      if (loading) loader = this.$loading.show();
      axios
        .get("province")
        .then(response => {
          if (loader != null) loader.hide();
          this.provinces = response.data.results;
          if (this.provinces.length > 0) {
            this.location.province = this.provinces[0].id;
          } else {
            this.location.province = 0;
          }
        })
        .catch(error => {
          if (loader != null) loader.hide();
          console.log(error.toString());
        });
    },
    fetchDistrict(province_id, loading, callback) {
      let loader = null;
      if (loading) loader = this.$loading.show();

      this.districts = [];
      axios
        .get("district?province_id=" + province_id)
        .then(response => {
          if (loading) loader.hide();
          this.districts = response.data.results;

          if (typeof callback === "undefined") {
            if (this.districts.length > 0) {
              this.location.district = this.districts[0].id;
            } else {
              this.location.district = 0;
            }
          } else {
            callback();
          }
        })
        .catch(error => {
          if (loading) loader.hide();
          console.log(error.toString());
        });
    },
    handleProvinceChange(value) {
      this.fetchDistrict(value, true, () => {
        this.createAddressDetail();
      });
    },
    handleDistrictChange(value) {
      this.createAddressDetail();
    },
    searchLocation(address) {
      if (!address) return;
      const l = JSON.parse(JSON.stringify(this.location));
      this.markers.push({
        position: {
          lat: l.latitude,
          lng: l.longitude
        }
      });
    }
  }
};
</script>
<style scoped>
</style>